"use client";

import useStringPlanner, {
  type StringPlannerData,
} from "@app/_hooks/useStringPlanner";
import { useEffect, useRef } from "react";

export const STRING_PLANNER_ORIGIN = "https://planner.stringfurniture.com";

type StringPlannerEvent = MessageEvent<{
  event: "byoLoaded" | "cartUpdate" | "designUpdate";
  data: StringPlannerData;
}>;

export default function StringPlannerFrame({ src }: { src: string }) {
  const ref = useRef<HTMLIFrameElement>(null);
  const { mutate: onChange } = useStringPlanner();

  useEffect(() => {
    function handleMessage(event: StringPlannerEvent) {
      if (event.origin !== STRING_PLANNER_ORIGIN) {
        return;
      }

      if (event.data.event === "byoLoaded") {
        ref.current?.contentWindow?.postMessage(
          { event: "enableCart", data: {} },
          "*",
        );
      }

      if (event.data.event === "cartUpdate") {
        void onChange(event.data.data);
      }
    }

    if (ref.current) {
      ref.current.src = src;
    }

    const controller = new AbortController();

    window.addEventListener("message", handleMessage, controller);

    return () => controller.abort();
  }, [onChange, ref, src]);

  return (
    <iframe
      ref={ref}
      width="100%"
      height={800}
      scrolling="no"
      frameBorder={0}
      className="my-16"
    />
  );
}
